import { useTranslation } from '@msdk/common'
import { FieldDefinition, FormFieldDefinition } from '@msdk/definitions'

export function useFieldLabel(fieldDef: FieldDefinition, formDef: FormFieldDefinition) {
  const t = useTranslation()
  const labelIDML = formDef.overrideIDML ?? fieldDef.idml
  const labelDescription = formDef.overrideDescription ?? fieldDef.description
  return t(labelIDML, labelDescription)
}
